// Account tiers that should be surfaced in route / stocking tables.
// Any other value (or an empty/unknown tier) renders as a blank cell.
export const DISPLAYABLE_ACCOUNT_TIERS = [
  'Tier 1',
  'Tier 2',
  '1 Drop per Week',
];

export function formatAccountTier(accountTier) {
  return DISPLAYABLE_ACCOUNT_TIERS.includes(accountTier) ? accountTier : '';
}
